import { formatDateForPostRequest } from "./formatDate";

export function formatPhotoRequest(userInput) {
  const { name, email, title, type, sport, due, description } = userInput;
  // 'due' should be a moment() object

  return {
    name: getVal(name),
    email: getVal(email),
    title: getVal(title),
    type: getVal(type),
    sport: getVal(sport),
    due: formatDateForPostRequest(getVal(due)),
    description: getVal(description)
  };
}

export function formatVideoRequest(userInput) {
  const { name, email, title, sport, due, description } = userInput;
  // 'due' should be a moment() object

  return {
    name: getVal(name),
    email: getVal(email),
    title: getVal(title),
    sport: getVal(sport),
    due: formatDateForPostRequest(getVal(due)),
    description: getVal(description),
    needed: formatDateForPostRequest(getVal(due))
  };
}

export function formatFacilityRequest(userInput) {
  const {
    name,
    email,
    phone,
    title,
    facility,
    type,
    due,
    description
  } = userInput;

  return {
    name: getVal(name),
    email: getVal(email),
    phone: getVal(phone),
    title: getVal(title),
    type: getVal(type),
    facility: getVal(facility),
    needed: formatDateForPostRequest(getVal(due)),
    description: getVal(description)
  };
}

function getVal(obj) {
  try {
    return obj.val;
  } catch (err) {
    console.error(err);
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/util/formatRequestData.js